"use strict";

import {isset} from '../js-utilities';
import ManagerHelper from './helpers/manager-helper';
import {generateValueOutput} from "./helpers/calculator-helpers";

// VitaminD
export default class VitaminDManager {
    constructor(controller, language) {
        this.controller = controller;
        this.language = language;

        this.$vitaminDSummary = $('#vitamin_d_summary');
        this.$vitaminDSummaryValue = $('#vitamin_d_summary_value');

        this.$vitaminDOutputCellLabel = $('#vitamin_d_output_cell_label');
        this.$vitaminDOutputCellValue = $('#vitamin_d_output_cell_value');
        // Icon is not being used but since the functionality works I don't want to remove it, in case we use it again
        this.$vitaminDOutputCellIcon = $('#vitamin_d_output_cell_icon');

        this.vitaminDHelper = new ManagerHelper('vitamin_d', this.controller, this.updateVitaminDAgeInfluence.bind(this));
    }

    reconfigureVitaminDInput() {
        if (this.vitaminDHelper) {
            this.vitaminDHelper.configureInput();
        }
    }

    callGenerateSliderGradients() {
        if (this.vitaminDHelper) {
            this.vitaminDHelper.callGenerateSliderGradient();
        }
    }

    // Would like to make this a generic method in the manager helper, but there's still enough deviation that this is simpler
    updateVitaminDAgeInfluence(vitaminD = this.controller.current_values.vitamin_d) {
        if (isset(vitaminD) && isset(this.controller.current_values.gender)) {
            const response = this.controller.calculator_4.ageChangeForVitaminD(vitaminD, 'si', this.controller.current_values.fractional_age, this.controller.current_values.gender);
            this.populateVitaminDOutput(response);
        } else {
            this.populateVitaminDOutput();
        }
    }

    // Would like to make this a generic method in the manager helper, but there's still enough deviation that this is simpler
    populateVitaminDOutput(response) {
        const vitaminDOutput = generateValueOutput('vitamin_d', response, this.controller);

        this.controller.current_age_changes.vitamin_d = vitaminDOutput.ageChange;
        this.controller.current_values.vitamin_d_change = vitaminDOutput.ageChangeText

        this.$vitaminDSummary.html(vitaminDOutput.summary);
        this.$vitaminDSummaryValue.html(vitaminDOutput.summaryValue);

        this.$vitaminDOutputCellLabel.html(vitaminDOutput.outputCellLabel);
        this.$vitaminDOutputCellValue.html(vitaminDOutput.outputCellValue).css('color', vitaminDOutput.outputCellColor);
        // Icon is not being used but since the functionality works I don't want to remove it, in case we use it again
        this.$vitaminDOutputCellIcon.prop('src', vitaminDOutput.outputCellIcon);

        this.controller.calculate_vascular_age();
    }

    // public method for controller to enable and disable UI controls
    enableControls(enable) {
        this.vitaminDHelper.enableControls(enable);
    }

}
